import { Center, Spinner } from "@chakra-ui/react";
import React from "react";
import { useEffect } from "react";

const IframeSupport = ({ isSupportLinkLoading, iframeData, setisSupportLinkLoading }) => {

  return (
    <>
      {isSupportLinkLoading ? (
        <Center w="100%" py="200px">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="red.500"
            size="xl"
          />
        </Center>
      ) : (
        <div className="w-screen h-screen p-5 box-border">
          <iframe
            src={iframeData}
            className="w-full h-full border-0"
            loading="lazy"
            title="Support Ticket"
            style={{ width: '100%', minHeight: '60vh' }}
          />
        </div>



      )}
    </>
  )
}

export default IframeSupport